<form [formGroup]="filterForm">
    <div fxLayout="row wrap">
        <mat-form-field fxFlex="100%">
            <input matInput placeholder="Name, Pfad..." formControlName="searchTerm">
        </mat-form-field>

        <div class="filter-section" fxFlex="33%">
            <h5>...nach Rolle</h5>
            <div formArrayName="filterByRoles" fxLayout="row wrap">
                <mat-checkbox *ngFor="let control of filterForm.controls.filterByRoles['controls']; let i = index"
                    [formControl]="control" fxFlex="100%">
                    {{ roleOptions[i].title }}
                </mat-checkbox>
            </div>
        </div>

        <div class="filter-section" fxFlex="33%">
            <h5>...nach Status</h5>
            <div formArrayName="filterByStates" fxLayout="row wrap">
                <mat-checkbox *ngFor="let control of filterForm.controls.filterByStates['controls'];; let i = index"
                    [formControl]="control" fxFlex="100%">
                    <span [innerHtml]="stateOptions[i].title"></span>
                </mat-checkbox>

            </div>
        </div>

        <div class="filter-section" fxFlex="33%">
            <h5>...nach Baustein</h5>
            <div formArrayName="filterByModules" fxLayout="row wrap">
                <mat-checkbox *ngFor="let control of filterForm.controls.filterByModules['controls']; let i = index"
                    [formControl]="control" fxFlex="100%">
                    <span [innerHtml]="moduleOptions[i].title"></span>
                </mat-checkbox>

            </div>
        </div>

    </div>
</form>